import React, { useState } from 'react';
import { Modal, Button, Header, Form, Message } from 'semantic-ui-react';
interface ModalArgs {
    modalOpen: boolean;
    onClose: VoidFunction;
    onSubmit: (rc: number) => void;
}
export default function MenuModal({ modalOpen, onClose, onSubmit }: ModalArgs) {
    const [roomcode, setRoomcode] = useState(0);
    const [error, setError] = useState("");
    function handleNumChange(event: { target: { name: any; value: any } }) {
        const { value } = event.target;
        setRoomcode(value);
    }
    //Checking roomcode here
    function checkRoomCode(code:number){
        // eslint-disable-next-line eqeqeq
        if(code%2==0){
            onSubmit(code)
        } else {
            setError("Nincs ilyen számmal folyamatban lévő játék!")
        }
    }
    return (
        <Modal
            as={Form}
            open={modalOpen}
            size='tiny'
            closeOnDimmerClick={true}
            closeOnEscape={true}
            onClose={onClose}
        >
            <Header icon='calculator' content='Szobaszám' as='h2' />
            <Modal.Content>
                <Form.Input
                    label='Szobaszám: (minden páros számot elfogad)'
                    required
                    type='number'
                    placeholder='99'
                    onChange={handleNumChange}
                />
                
                {error!==""?<Message compact negative content={error}/>:null}
            </Modal.Content>
            <Modal.Actions>
                <Button
                    color='red'
                    icon='times'
                    content='Mégse'
                    onClick={(e) => {
                        e.preventDefault();
                        onClose();
                    }}
                />
                <Button
                    type='submit'
                    color='green'
                    icon='game'
                    content='Csatlakozás'
                    onClick={(e) => checkRoomCode(roomcode)}
                />
            </Modal.Actions>
        </Modal>
    );
}
